import React, { ReactNode } from 'react'
import { LinkBtnAux } from '../common/LinkBtn';
import { CTAButton } from '../footer/Footer';

interface ActionBannerProps{
  title:string;
  desc:string;
  img:string;
  children:ReactNode;
}

const ActionBanner = ({title, desc, img, children}:ActionBannerProps) => {
  return (
    <div className='px-4 lg:px-0'>
      <div style={{
          backgroundImage:"url(/img/perksbanner.png)", 
          backgroundPosition:'center',
          backgroundSize:'cover',
          backgroundRepeat:'no-repeat'
          }} className='flex rounded-xl lg:rounded-none mb-14 justify-between items-center flex-col-reverse lg:flex-row pb-6 lg:pb-0'>
        <div className='lg:w-[40%] p-6 lg:pl-[4rem] space-y-6'>
          <h1 className='text-white font-bold text-[18px] lg:text-3xl '>{title}</h1>
          <p className='text-white text-[14px] lg:text-[12px] '>{desc}</p>
          <div>
            {children}          
          </div>

        </div>
        <img className='lg:w-[45%] h-[400px]' src={img} alt="" />
      </div>      
    </div>

  )
}

export default ActionBanner

export const bannerData = [
  {
    title: 'Would you like to become verified recycler on our platform?',
    desc:'Join Africa’s fastest-growing waste banking platform and connect with more waste generators while increasing efficiency and revenue.',
    img:'/img/b1.png',
    children: <LinkBtnAux style={'px-[1rem]'} link='/onboarding' title='Register as a Recycler'/>
  },
  {
    title: 'Do you have any waste that you would like to dispose and also earn while at it?',
    desc:'Get access to hundreds of waste collectors nearest to you with the Pakam  user  App.  Keep your environment clean and earn.',
    img:'/img/b2.png',
    children: <CTAButton/>
  },
  {
    title: 'Would you like to partner with Pakam?',
    desc:'Join Africa’s fastest-growing waste banking platform and connect with more waste generators while increasing efficiency and revenue.',
    img:'/img/b3.png',
    children: <CTAButton/>
  },
]


